module.exports = __webpack_public_path__ + "img/like.bcbfdb1e.svg";